export const maxPaginationLinks = 7
